// アバターのフォールバック表示に使うイニシャル生成の共有ユーティリティ。
// ダッシュボードのユーザーアバター（UserAvatar）とコメントピンのアバター（CommentAvatar）で
// 同一のイニシャルを出すために共有する。両者が別実装だと「山花」と「山」のように見た目が
// ずれてしまうため、正本をここへ一本化する。

// 表示名からフォールバック用イニシャルを生成する。
// - 空白区切りで複数トークンなら先頭 2 トークンの頭文字を結合（例:「山田 花子」→「山花」）
// - 単一トークンなら先頭 1 グラフェム（CJK でも英字でも 1 文字）
// - いずれも大文字化する
export function getAvatarInitials(name: string): string {
  const parts = name.split(/\s+/u).filter((part) => part.length > 0);
  if (parts.length === 0) return "";
  if (parts.length === 1) {
    // 単一トークンの場合は先頭 1 文字（CJK でも英字でも 1 文字を表示）。
    const first = parts[0]!;
    return takeFirstGrapheme(first).toUpperCase();
  }
  // 複数トークンなら先頭 2 個の頭文字を結合。
  return parts
    .slice(0, 2)
    .map((part) => takeFirstGrapheme(part))
    .join("")
    .toUpperCase();
}

// サロゲートペアや結合文字を考慮して先頭の 1 グラフェム（または 1 文字）を取得する。
export function takeFirstGrapheme(value: string): string {
  if (value.length === 0) return "";
  // ES2018 以降の Intl.Segmenter があれば使用。
  const SegmenterCtor = (Intl as unknown as { Segmenter?: typeof Intl.Segmenter | undefined })
    .Segmenter;
  if (typeof SegmenterCtor === "function") {
    const segmenter = new SegmenterCtor("ja", { granularity: "grapheme" });
    const first = segmenter.segment(value)[Symbol.iterator]().next().value as
      | { segment: string }
      | undefined;
    if (first) return first.segment;
  }
  // フォールバックとしてコードポイント単位の先頭 1 つ。
  return Array.from(value)[0] ?? "";
}
